const Layout = () => import('@/layout/index.vue');

export default {
  path: '/toufang',
  name: 'Toufang',
  component: Layout,
  meta: {
    icon: 'link',
    title: '投放工具',
    rank: 5,
    permission: ['root', 'admin', 'user']
  },
  children: [
    {
      path: '/toufang/pageLinkSet',
      name: 'PageLinkSet',
      component: () => import('@/views/toufang/pageLinkSet/index.vue'),
      meta: {
        title: '投放链接设置',
        icon: 'tools'
      }
    },
    {
      path: '/toufang/deductQuantity',
      name: 'deductQuantity',
      component: () => import('@/views/toufang/deductQuantity/index.vue'),
      meta: {
        title: '投放扣量',
        icon: 'Connection'
      }
    },
    {
      path: '/toufang/information',
      name: 'information',
      component: () => import('@/views/toufang/information/index.vue'),
      meta: {
        title: '投放产品',
        icon: 'DataAnalysis'
      }
    }
  ]
};
